import { create, valueOf } from 'microstates';
import NotificationState from './notification-state';
import { trackHeapEvent } from '../lib/tracking-utils';

export default class ErrorsState {
  count = Number;
  errors = [NotificationState];

  add(message, { validationType = null } = {}) {
    trackHeapEvent('Personalize Error Notification Seen', { message, validationType });

    const state = this.count.increment();
    return state.errors.unshift(create(NotificationState, { id: state.count.state, message, type: 'error', validationType }));
  }

  addWarning(message, { validationType = null } = {}) {
    trackHeapEvent('Personalize Warning Notification Seen', { message, validationType });

    const state = this.count.increment();
    return state.errors.unshift(create(NotificationState, { id: state.count.state, message, type: 'warning', validationType }));
  }

  remove(errorId) {
    return this.errors.filter(e => e.id.state !== errorId);
  }

  removeAll() {
    return this.errors.set([]);
  }
}
